module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel02_770_280_vi-6ca576003f55c096a9dbc36671f3f7da.jpg";